<template>
    <div class="link-picker-container">
        <div v-if="!this.message"
             class="link-picker">
            <div class="parse-result-container">
                <span class="parse-category">{{categoryNames[parseResult.index]}}</span>
                <a class="parse-link"
                   :href="data">
                    {{parseResult.result}}
                </a>
            </div>
            <input @input="parse"
                   ref="input"/>
            <div class="category-picker">
                <div v-for="(name, index) in this.categoryNames"
                     :key="index"
                     :class="{'category-tab': true,
                              'invisible': !isVisible(name),
                              'selected': selectedCategory === index}"
                     @click="selectedCategory = index">
                    {{name}}
                </div>
            </div>
            <div class="links-list">
                <div v-for="(name, link) in linkData[selectedCategory]"
                     :key="link"
                     class="link-item button flat-button"
                     @click="setLink(link)">
                    <div class="link-name">{{name}}</div>
                    <div class="link-dest">{{link}}</div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="message">{{this.message}}</div>
        </div>
    </div>
</template>

<script>
	import LinkService from "../../services/LinkService";

	export default {
		name: "LinkPicker",
		created() {
			let loader = LinkService.load();
			if (loader) {
				loader.then(() => {
					this.loadLinks();
				}).catch(e => {
					this.message = "加载失败\n" + e;
				});
			} else {
				this.loadLinks();
			}
		},
		props: {
			data: {
				required: false,
				default: ""
			},
			visible: {
				type: Array,
				required: false
			}
		},
		data() {
			return {
				message: "加载中",
				categoryNames: [],
				linkData: [],
				parseResult: 0,
				selectedCategory: 0
			}
		},
		methods: {
			getValue() {
				return this.$refs.input.value;
			},
			reload() {
				LinkService.load().then(() => {
					this.loadLinks();
				}).catch(e => {
					this.message = "加载失败\n" + e;
				});
			},
			parse() {
				if (this.$refs.input) {
					this.parseResult = LinkService.parse(this.$refs.input.value);
					return true;
				}
			},
			loadLinks() {
				this.categoryNames = LinkService.getNames();
				this.linkData = LinkService.data;
				this.message = "";
				setImmediate(() => {
					this.$refs.input.value = this.data;
					this.parse();
					this.selectedCategory = this.parseResult.index;
				});
			},
			setLink(link) {
				this.$refs.input.value = link;
				this.parse();
			},
			isVisible(name) {
				return !this.visible || this.visible.includes(name);
			}
		}
	}
</script>

<style scoped lang="scss">
    .link-picker-container {
        overflow: scroll;
        resize: vertical;
        height: 400px;
    }

    .link-picker {
        display: flex;
        height: 100%;
        flex-direction: column;
    }

    .parse-result-container {
        padding: 8px 0;
    }

    .parse-category {
        background-color: $p-fg;
        color: $p-bg;
        padding: 4px;
    }

    .parse-link {
        color: $s-accent;
    }

    input {
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 4px;
    }

    .category-picker {
        display: flex;
        flex-direction: row;
    }

    .category-tab {
        flex-grow: 1;
        text-align: center;
        padding: 4px;
        cursor: default;
        border-bottom: solid 2px $p-accent;
    }

    .category-tab.invisible {
        display: none;
    }

    .category-tab:hover {
        background-color: $p-accent;
    }

    .category-tab.selected {
        border-bottom: solid 2px $p-fg;
    }

    .links-list {
        overflow-y: scroll;
    }

    .link-item.button {
        margin-bottom: -2px;
        padding: 4px;
        text-align: left;
    }

    .link-dest {
        font-size: 12px;
        color: $s-accent;
    }
</style>